import React from 'react';
import { Card, CardContent, TextField, FormControl, InputLabel, Select, MenuItem, Button, IconButton, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid';

import { Search as SearchIcon, FilterList as FilterIcon, Refresh as RefreshIcon } from '@mui/icons-material';

interface StickyFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedType?: string;
  onTypeChange?: (value: string) => void;
  typeOptions?: Array<{ value: string; label: string }>;
  selectedStatus?: string;
  onStatusChange?: (value: string) => void;
  statusOptions?: Array<{ value: string; label: string }>;
  onRefresh?: () => void;
  onAdvancedFilters?: () => void;
  children?: React.ReactNode;
}

const StickyFilters: React.FC<StickyFiltersProps> = ({
  searchTerm,
  onSearchChange,
  selectedType,
  onTypeChange,
  typeOptions = [],
  selectedStatus,
  onStatusChange,
  statusOptions = [],
  onRefresh,
  onAdvancedFilters,
  children
}) => {
  return (
    <Card 
      sx={{ 
        mb: 3, 
        borderRadius: 2,
        position: 'sticky',
        top: 64,
        zIndex: 1000,
        backgroundColor: 'background.paper'
      }}
    >
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, md: 3 }}>
            <TextField
              fullWidth
              placeholder="Cauta..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
              }}
              sx={{ borderRadius: 2 }}
            />
          </Grid>
          
          {typeOptions.length > 0 && onTypeChange && (
            <Grid size={{ xs: 12, md: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Tip</InputLabel>
                <Select
                  value={selectedType || 'all'}
                  onChange={(e) => onTypeChange(e.target.value)}
                  label="Tip"
                >
                  <MenuItem value="all">Toate</MenuItem>
                  {typeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          
          {statusOptions.length > 0 && onStatusChange && (
            <Grid size={{ xs: 12, md: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={selectedStatus || 'all'}
                  onChange={(e) => onStatusChange(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="all">Toate</MenuItem>
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          
          {onAdvancedFilters && (
            <Grid size={{ xs: 12, md: 2 }}>
              <Button
                variant="outlined"
                startIcon={<FilterIcon />}
                fullWidth
                onClick={onAdvancedFilters}
                sx={{ height: 56, borderRadius: 2 }}
              >
                Filtre Avansate
              </Button>
            </Grid>
          )}
          
          {onRefresh && (
            <Grid size={{ xs: 12, md: 1 }}>
              <Tooltip title="Actualizeaza">
                <IconButton onClick={onRefresh}>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
          
          {children && (
            <Grid size={12}>
              {children}
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default StickyFilters;
